<template>
  <TabbedPortletOpportunity>
    <TabbedPortletHead>
      <li class="nav-item">
        <a
          href=""
          class="nav-link"
          :class="{ 'active': selectedTab === tabs.CONSUMER_SECTION_YOUR_DETAILS_TAB }"
          @click.prevent="selectTab(tabs.CONSUMER_SECTION_YOUR_DETAILS_TAB)">Your Details</a>
      </li>
      <li class="nav-item">
        <a
          href=""
          class="nav-link"
          :class="{ 'active': selectedTab === tabs.CONSUMER_SECTION_TRIP_DETAILS_TAB }"
          @click.prevent="selectTab(tabs.CONSUMER_SECTION_TRIP_DETAILS_TAB)">Trip Details</a>
      </li>
      <li class="nav-item">
        <a
          href=""
          class="nav-link"
          :class="{ 'active': selectedTab === tabs.CONSUMER_SECTION_TRIP_INCLUSIONS_TAB }"
          @click.prevent="selectTab(tabs.CONSUMER_SECTION_TRIP_INCLUSIONS_TAB)">Trip Inclusions</a>
      </li>
    </TabbedPortletHead>

    <TabbedPortletBody>
      <div class="tab-content">
        <TabbedPortletBodyTab :show="selectedTab === tabs.CONSUMER_SECTION_YOUR_DETAILS_TAB">
          <TabYourDetails :validationGroupName="validationGroupName" />
        </TabbedPortletBodyTab>

        <TabbedPortletBodyTab :show="selectedTab === tabs.CONSUMER_SECTION_TRIP_DETAILS_TAB" >
          <TabTripDetails :validationGroupName="validationGroupName" />
        </TabbedPortletBodyTab>

        <TabbedPortletBodyTab :show="selectedTab === tabs.CONSUMER_SECTION_TRIP_INCLUSIONS_TAB">
          <TabTripInclusions
            :data="data"
            :isCompletedQuote="isCompletedQuote"
            :isImporting="isImporting"
            @import="importInclusions" />
        </TabbedPortletBodyTab>
      </div>
    </TabbedPortletBody>
  </TabbedPortletOpportunity>
</template>

<script>
import TabbedPortletOpportunity from '@/components/_shared/tabbed-portlet-opportunity/TabbedPortletOpportunity.vue'
import TabbedPortletHead from '@/components/_shared/tabbed-portlet/TabbedPortletHead.vue'
import TabbedPortletBody from '@/components/_shared/tabbed-portlet/TabbedPortletBody.vue'
import TabbedPortletBodyTab from '@/components/_shared/tabbed-portlet/TabbedPortletBodyTab.vue'

import TabYourDetails from './TabYourDetails.vue'
import TabTripDetails from './TabTripDetails.vue'
import TabTripInclusions from './TabTripInclusions.vue'

export default {
  name: 'TabConsumerSection',
  inject: ['$v'],
  components: {
    TabbedPortletOpportunity,
    TabbedPortletHead,
    TabbedPortletBody,
    TabbedPortletBodyTab,
    TabYourDetails,
    TabTripDetails,
    TabTripInclusions
  },
  data () {
    const CONSUMER_SECTION_YOUR_DETAILS_TAB = 'consumer-section-your-details-tab'
    const CONSUMER_SECTION_TRIP_DETAILS_TAB = 'consumer-section-trip-details-tab'
    const CONSUMER_SECTION_TRIP_INCLUSIONS_TAB = 'consumer-section-trip-inclusions-tab'

    return {
      selectedTab: CONSUMER_SECTION_YOUR_DETAILS_TAB,
      tabs: {
        CONSUMER_SECTION_YOUR_DETAILS_TAB,
        CONSUMER_SECTION_TRIP_DETAILS_TAB,
        CONSUMER_SECTION_TRIP_INCLUSIONS_TAB
      }
    }
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    validationGroupName: {
      type: String,
      required: true
    },
    isCompletedQuote: {
      type: Boolean,
      required: false
    },
    isImporting: {
      type: Boolean,
      required: false
    }
  },
  methods: {
    selectTab (tabName) {
      this.selectedTab = tabName
    },
    importInclusions () {
      this.$emit('import')
    }
  }
}
</script>

<style lang="scss" scopep>
</style>
